module.exports = __webpack_public_path__ + "static/img/1_2_6.d63c5118.jpg";